import { MDText } from 'i18n-react';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import { POST_SALE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsPostSale';

import { useSaleDetailsSub } from '../../hooks/useSaleDetailsSub';
import { useVehicleCollectionSub } from '../../hooks/useVehicleCollectionSub';

import Texts from './NegativeEquityTerm.json';

import styles from './NegativeEquityTerm.scss';

const localT = new MDText(Texts);

export const NegativeEquityTerm = ({ isSaleDetailsPage = false }: { isSaleDetailsPage?: boolean }) => {
  const { hasNegativeEquity } = useSaleDetailsSub();
  const { isSaleComplete } = useVehicleCollectionSub();

  if (!hasNegativeEquity || isSaleComplete) {
    return null;
  }

  return (
    <p data-thc-style-override className={styles.negativeEquityTerms}>{localT.translate('terms', {
      learnMore: (
        <Hyperlink
          inherit
          as="a"
          data-thc-style-override="true"
          href="https://help.motorway.co.uk/hc/en-gb/articles/17402031308060-How-do-I-sell-my-vehicle-with-negative-equity"
          label={localT.translate('learnMore')}
          onClick={() => POST_SALE_SNOW_PLOW_EVENTS.LEARN_MORE_NEGATIVE_EQUITY(isSaleDetailsPage)}
          target="_blank"
          variant="secondary"
        />
      ),
    })}</p>
  );
};
